import { useEffect, useState } from "react";
import { Alert, Modal, Spin } from "antd";
import { makeApiRequest } from "../../lib/api";
import { extractIdFromExtendedId, WAITLIST } from "../../lib/lib";
import { TypeParams } from "../../types";
import { useTranslation } from "react-i18next";

interface Form4SuccessProps {
  params: TypeParams; // Define the type of the ccid prop
  placeId: number;
  dateId?: number | string;
}

const Form4Success: React.FC<Form4SuccessProps> = ({ params, placeId, dateId }) => {
  const { t } = useTranslation();
  const [shortDateId, setShortDateId] = useState<number>();
  const [isWaitlist, setIsWaitlist] = useState(`${shortDateId}` === `${WAITLIST}`);
  const [date, setDate] = useState(null);
  const [place, setPlace] = useState(null);
  // const [finalMessageSent, setFinalMessageSent] = useState(false);
  const [error, setError] = useState("");
  const { success } = Modal;

  // FORM 1 SUBMIT: send email or phone number to validate
  const onLoadForm = async () => {
    setError(""); // Clear previous errors
    try {
      // GET ANPASSUNG PLACE
      let action = "";
      let content: any = {};
      action = "REACT_GET_ANPASSUNG_PLACE";
      content = { place_id: placeId };
      const responsePlace: string = (await makeApiRequest(params, action, content)) as any;
      const parsed = JSON.parse(responsePlace);
      if (!parsed || parsed.STATUS !== "OK") {
        setError(t("anpassung.success.errorLoadingPlace"));
        return;
      }
      setPlace(parsed.CONTENT);

      // GET ANPASSUNG DATE
      if (dateId && dateId !== WAITLIST && dateId !== `public_${WAITLIST}`) {
        action = "REACT_GET_ANPASSUNG_DATE";
        content = { date_id: dateId };
        const response = (await makeApiRequest(params, action, content)) as any;
        const parsed_response = JSON.parse(response);
        if (!parsed || parsed.STATUS !== "OK") {
          setError(t("anpassung.success.errorLoadingDate"));
          return;
        }
        const anpassungDate = parsed_response.CONTENT;
        setDate(anpassungDate);
      }
    } catch (error) {
      console.error(error);
      setError(t("anpassung.success.genericError"));
    }
  };

  useEffect(() => {
    if (!place) {
      return;
    }

    // setFinalMessageSent(true);

    const placeInfo = (
      <>
        <div className="my-md">
          <a href={place["txt_url"]} target="_blank" rel="noreferrer">
            {t("anpassung.success.placeInfo", { publicName: place["txt_public_name"] })}
          </a>
        </div>
      </>
    );

    if (params.page === "infotermin_registration") {
      success({
        onOk: () => {
          window.location.href = place["txt_url"];
        },
        okText: t("anpassung.success.okText"),
        // onCancel: () => {
        //   window.location.href = place["txt_url"];
        // },
        title: t("anpassung.success.infoTitle"),
        content: (
          <>
            {t("anpassung.success.infoMessage")}
            <br />
            <br />
            {placeInfo}
          </>
        ),
      });
    }

    if (place && date) {
      if (isWaitlist) {
        success({
          onOk: () => {
            window.location.href = place["txt_url"];
          },
          okText: t("anpassung.success.okText"),
          // onCancel: () => {
          //   window.location.href = place["txt_url"];
          // },
          title: t("anpassung.success.waitlistTitle"),
          content: (
            <>
              {t("anpassung.success.waitlistMessage", { placeName: place["txt_public_name"] })}
              <br />
              <br />
              {placeInfo}
            </>
          ),
        });
      } else if (params.page !== "infotermin_registration" && !isWaitlist && date) {
        success({
          onOk: () => {
            window.location.href = place["txt_url"];
          },
          okText: t("anpassung.success.okText"),
          // onCancel: () => {
          //   window.location.href = place["txt_url"];
          // },
          title: t("anpassung.success.appointmentTitle"),
          content: (
            <>
              {t("anpassung.success.appointmentMessage", {
                placeName: place["name"],
                secondName: place["second_name"] ? `- ${place["second_name"]}` : "",
                date: date["local_ws_date"],
                time: date["local_ws_time"],
              })}
              <br />
              <br />
              {placeInfo}
            </>
          ),
        });
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date, place]);

  useEffect(() => {
    if (!error) {
      return;
    }

    let placeInfo = <></>;

    if (place) {
      placeInfo = (
        <>
          <div className="my-md">
            <a href={place["txt_url"]} target="_blank" rel="noreferrer">
              {t("anpassung.success.placeInfo", { publicName: place["txt_public_name"] })}
            </a>
          </div>
        </>
      );

      Modal.error({
        title: t("anpassung.success.errorTitle"),
        content: (
          <>
            <Alert message={error} type="error" />
            <br />
            {placeInfo}
          </>
        ),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  // INIT
  useEffect(() => {
    const localShortDateId: number = extractIdFromExtendedId(`${dateId}`);
    setShortDateId(localShortDateId);
    setIsWaitlist(`${localShortDateId}` === `${WAITLIST}`);
    onLoadForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateId]);

  if (!placeId) {
    return <div>{t("anpassung.success.sessionInterrupted")}</div>;
  }

  if (!place || (!date && !isWaitlist && params.page !== "infotermin_registration")) {
    return (
      <div className={"my-lg"}>
        <Spin />
      </div>
    );
  }

  return (
    <>
      <div>
        <div style={{ fontSize: "2rem", color: "green" }}>✔</div>
      </div>
    </>
  );
};

export default Form4Success;
